<template>
  <el-card class="main-content">
    <div class="actions">
      <div class="publish-switch">
        <i class="el-icon-view icon-preview" @click="routeToPreview"></i>
        <el-switch
          v-model="published"
          inactive-text="发布:"
          active-color="#13ce66"
          inactive-color="#f3f3f3"
        >
        </el-switch>
      </div>
      <DeletePopover placement="bottom" @delete="deleteRepo">
        <el-button class="main-button" size="small" type="danger"
          >删除</el-button
        >
      </DeletePopover>
      <el-button
        class="main-button ml-10"
        type="primary"
        size="small"
        @click="updateRepo"
        :loading="updating"
        >保存</el-button
      >
    </div>
    <div class="row">
      <div class="col">
        <span>资料名:</span>
        <el-input v-model="repo.title"></el-input>
      </div>
      <div class="col">
        <span>版本号:</span>
        <el-input v-model="repo.version"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span>节点:</span>
        <NodesSelect :id.sync="repo.node.id"></NodesSelect>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span>标签:</span>
        <TagsEdit
          :tags="repo.tags"
          @add="onTagAdd"
          @delete="onTagDelete"
        ></TagsEdit>
      </div>
    </div>
    <div class="readme">
      <span>描述:</span>
      <TextEditor :content.sync="repo.readme"></TextEditor>
    </div>
    <div class="script">
      <el-button
        type="text"
        v-if="!scriptEditVisible"
        @click="scriptEditing = !scriptEditing"
        >+ Script</el-button
      >
      <el-button type="text" v-if="scriptEditVisible" @click="scriptEditingOff"
        >- Script</el-button
      >
      <div class="col script-editor" v-if="scriptEditVisible">
        <span>Script:</span>
        <el-input type="textarea" v-model="repo.script" :rows="5"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="col archive-upload">
        <span>文件资料</span>
        <div class="archives-list">
          <ArchivesList
            :archives="repo.archives"
            deletable
            @delete="onArchiveDelete"
          ></ArchivesList>
        </div>
      </div>
      <ArchiveUpload
        @add="onArchiveAdd"
        @delete="onArchiveDelete"
      ></ArchiveUpload>
    </div>
  </el-card>
</template>

<script>
import { OopsErrorELMessage, RepoMixin } from "@/mixins";
import DeletePopover from "@/components/DeletePopover";
import NodesSelect from "@/components/NodesSelect";
import TagsEdit from "@/components/TagsEdit";
import TextEditor from "@/components/TextEditor";
import ArchiveUpload from "@/components/ArchiveUpload";
import ArchivesList from "@/components/ArchivesList";
export default {
  name: "RepoEdit",
  mixins: [OopsErrorELMessage, RepoMixin],
  components: {
    DeletePopover,
    NodesSelect,
    TagsEdit,
    TextEditor,
    ArchiveUpload,
    ArchivesList
  },
  data() {
    return {
      updating: false,
      deleting: false,
      scriptEditing: false
    };
  },
  computed: {
    updateRequest() {
      return {
        title: this.repo.title,
        version: this.repo.version,
        readme: this.repo.readme,
        script: this.repo.script,
        node_id: this.repo.node.id
      };
    },
    scriptEditVisible() {
      return this.repo.script !== "" || this.scriptEditing;
    }
  },
  methods: {
    updateRepo() {
      this.updating = true;
      this.$http
        .patch(this.repoURI, this.updateRequest)
        .then(resp => {
          this.repo = resp.data;
          this.$message({
            type: "success",
            message: "更新完成",
            duration: 600
          });
          this.updating = false;
        })
        .catch(() => {
          this.oopsError();
          this.updating = false;
        });
    },
    deleteRepo() {
      this.deleting = true;
      this.$http
        .delete(this.repoURI)
        .then(() => {
          this.$router.push({ name: "admin_repos" });
        })
        .catch(() => {
          this.oopsError();
          this.deleting = false;
        });
    },
    publishRepoSwitch() {
      this.$http
        .patch(this.repoURI, {
          publish: !this.published
        })
        .then(resp => {
          this.repo.published_at = resp.data.published_at;
        })
        .catch(err => this.oopsError(err));
    },
    onTagAdd(name) {
      this.$http
        .post(`${this.repoURI}/tags`, { name })
        .then(resp => {
          this.repo.tags.push(resp.data);
        })
        .catch(() => this.oopsError());
    },
    onTagDelete(tag) {
      this.$http
        .delete(`${this.repoURI}/tags/${tag.id}`)
        .then(() => {
          let idx = this.repo.tags.findIndex(t => t.id === tag.id);
          this.repo.tags.splice(idx, 1);
        })
        .catch(() => this.oopsError());
    },
    onArchiveAdd(archive) {
      this.$http
        .post(`${this.repoURI}/archives`, {
          archive_id: archive.id
        })
        .then(() => {
          this.repo.archives.push(archive);
        })
        .catch(() => this.oopsError());
    },
    onArchiveDelete(archive) {
      this.$http
        .delete(`${this.repoURI}/archives/${archive.id}`)
        .then(() => {
          let idx = this.repo.archives.findIndex(a => a.id === archive.id);
          this.repo.archives.splice(idx, 1);
        })
        .catch(() => this.oopsError());
    },
    scriptEditingOff() {
      this.repo.script = "";
      this.scriptEditing = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
.actions {
  display: flex;
  justify-content: flex-end;
  & .publish-switch {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
}
.icon-preview {
  margin-right: 5px;
  color: #68b4ff;
  cursor: pointer;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;
  margin: 10px 0;
}
.col {
  display: grid;
  align-items: center;
  grid-template-columns: 80px 1fr;
}
.script-editor {
  margin-top: -15px;
}
.archive-upload {
  align-items: unset;
}
</style>
